/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import 'moment-timezone';
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import { useDispatch, useSelector } from "react-redux";
import { Scrollbars } from 'react-custom-scrollbars-2';
import CommonPagination from "../commonModel/commonPagination";
import EmptySpaceFieldValid from "../../CheckValid/EmptySpaceValid";
import CheckValid from "../../CheckValid/checkValid";
import { ClearFormSetFutios } from "../../redux/actions/adminAction";
import CommonewModel from "../commonModel/commonModel";
import EDIT from "../../assets/image/EDIT.svg";
import deleteSvg from "../../assets/image/deleteSvg.svg";
import LoadingButton from "../RecipientManagement/LoadingButton";
import DeleteConfirmModal from "../RecipientManagement/DeleteConfirmModal";


const DocumentType = () => {
  const { websocket } = useContext(WebSocketContext);
  const {  ClearFormSet,docTypeList} = useSelector((state) => state.adminReducers);
  const [currentPage, setCurrentPage] = useState(1)
  const [topic,setTopic] = useState("")
  const [errorTopic,setErrorTopic] = useState("")
  const dispatch = useDispatch()

  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    modalType: "",
    Data: {}
});

  const openModal = (id,status,title) => {
    setShowModalNew({
        ...showModalNew,
        open: !showModalNew?.open,
        title: status,
        subtitle: "Create New Model",
        modalType: title?title:"delete-popup",
        Data: id
    })
};

  const renderTrack = ({ style, ...props }) => {
    const trackStyle = {
      display: "none"
    };
    return <div style={{ ...style, ...trackStyle }} {...props} />;
  };

  const currentFunction = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (ClearFormSet?.url === "document_type_add" && ClearFormSet?.action === 200) {
        call()
        setTopic("");   
    }
    setTimeout(() => {
        dispatch(ClearFormSetFutios({
            url: "",
            action: ""
        }))
    }, 1000)
}, [ClearFormSet, dispatch])

  useEffect(() => {
      call()
  }, [websocket, currentPage])

  function call(){
    let param = {
        "transmit": "single",
        "url": "doc_type_list",
        "request": {
          "limit": "20",
          "page_no": currentPage,
        }
      }
      wsSend_request(websocket, param)
  }

  function submit(e){
    e.preventDefault()
    if(topic){
        let param = {
            "transmit": "single",
            "url": "document_type_add",
            "request": {
                "title":topic
            }
          }
          wsSend_request(websocket, param)
    }else{
        CheckValid(topic, { type: 'Title', error: setErrorTopic })
    }
  }

      const [removeModal, setRemoveModal] = useState({
      open: false,
      machine: null,
    });
    const handleRemove = (machine) => {
      setRemoveModal({ open: true, machine });
    };
    const closeRemoveModal = () => {
      setRemoveModal({ open: false, machine: null });
    };
    const confirmRemove = () => {

                  let payload = {
                      "transmit": "single",
                      "url": "doc_type_delete",
                      "request": {
                          "doc_type_id": removeModal?.machine?.id
                      }
                  }      
      wsSend_request(websocket, payload);
      setRemoveModal({ open: false, machine: null });
      call();
    };

  return (
    <>
        <div className="row">
            <div className="col-12">
                <div className="row ms-1 me-2 d-flex justify-content-start align-items-baseline Height">
                    <div className="col-4 ms-1 mb-3 mt-2">
                        <input type="text" 
                        className="form-control Poppins_400" 
                        placeholder="Enter document type"
                        value={topic}
                        onKeyUp={(e) => CheckValid(e.target.value, { type: 'Title', error: setErrorTopic })}
                        onKeyDown={EmptySpaceFieldValid}
                        onChange={(e)=>setTopic(e.target.value)}
                        />
                        {errorTopic && <span className="input_error">{errorTopic}</span>}
                    </div>
                    {/* <div className="col-4 mb-3 mt-2">
                    <button className="ps-4 pe-4 pt-2 pb-2"  style={{ backgroundColor: "#181818",cursor:"pointer" ,border: "unset", color: "#FFFFFF", borderRadius: "17px" }}  onClick={submit}>+Add</button>
                    </div> */}
                     <div className="col-4  mt-3">
                                        <LoadingButton onClick={submit} text="+ Add" />
                                        </div>
                </div>            
            </div>
        </div>
      <div style={{ margin: "2px" }} className="fixTableHead ms-2 me-2">
        <Scrollbars
          style={{ height: docTypeList?.pagination?.total_records > 20 ? "calc(100vh - 220px)" : "calc(100vh - 280px)" }}
          renderView={props => <div {...props} className="view" />}
          renderTrackHorizontal={renderTrack}
          className="ScrollbarsSidebar"
        >
          <Table responsive style={{ borderTopLeftRadius: "19px", borderTopRightRadius: "19px" }}>
            <thead style={{ position: "sticky", top: "0px" }}>
              <tr className="user-management-table-heading">
                <th>Document Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody id="contact-us-table">
              {docTypeList?.list.length > 0 ? (
                docTypeList.list.map((payment) => (
                  <tr key={payment.id} className="user-management-table-detail">
                    <td style={{ cursor: "default",width:"100%" }}>{payment.title}</td>
                    <td style={{ cursor: "default",minWidth:"200px" }}>
                    {/* <span style={{backgroundColor:"#F7ABAB",color:"#000000",borderRadius:"4px",cursor:"pointer"}} className="ps-5 pe-5" onClick={()=>openModal(payment.id,"title","Edit")}>Edit</span>
                    <span style={{backgroundColor:"#B6EFBB",color:"#000000",borderRadius:"4px",cursor:"pointer"}} className="mx-2 ps-5 pe-5" onClick={()=>openModal(payment.id,"doc_type_delete")} >Delete</span> */}
                     <span style={{borderRadius:"4px",cursor:"pointer"}} className="" onClick={()=>openModal(payment.id,"title","Edit")}>
                                         <img src={EDIT} alt="edit" title="Edit" />
                                        </span>
                                        <span
                                        onClick={() => handleRemove(payment)}
                                        // onClick={()=>openModal(payment.id,"doc_type_delete")}
                                         style={{color:"#000000",borderRadius:"4px",cursor:"pointer"}} className="mx-2">
                                        <img src={deleteSvg} alt="edit" title="Delete" />
                                        </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">Data not found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Scrollbars>
        {docTypeList?.pagination?.total_records > 20 && (<CommonPagination
          currentPage={currentPage}
          paginationLength={docTypeList?.pagination}
          currentFunction={currentFunction}
        />)}
      </div>
      {showModalNew?.open && (<CommonewModel setShowModalNew={setShowModalNew} showModalNew={showModalNew} />)}
    {removeModal.open && (
        <DeleteConfirmModal
          open={removeModal.open}
          onClose={closeRemoveModal}
          onConfirm={confirmRemove}
          message="Are you sure you want to Delete this Document type?"
        />
      )}
    </>
  );
};

export default DocumentType;
